<style lang="scss" scoped>

</style>

<template>

  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="text-xs-center mt-2">{{content.title}}</h2>
    </v-flex>

    <v-flex xs12>

      <v-layout row wrap justify-center>

        <v-flex xs12 lg10 xl8 class="mt-2">

          <template v-if="devices">
            <div>
              <v-data-table
                :loading="loading"
                :headers="headers"
                :items="notifications"
                :pagination.sync="pagination"
                :total-items="total"
                :rows-per-page-items="[5,10,25,50]"
                :rows-per-page-text="content.rowsperpage"
                :no-data-text="''"
                :no-results-text="content.noresults"
                class="elevation-1">
                <template v-slot:headers="props">
                  <tr v-if="$vuetify.breakpoint.smAndUp">
                    <th v-for="header in props.headers" :key="header.text" :class="textdir">
                      {{ header.text }}
                    </th>
                  </tr>
                  <tr v-else>
                    <th v-for="header in XSheaders" :key="header.text" :class="textdir">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template v-if="$vuetify.breakpoint.xsOnly" v-slot:items="nots">
                  <td class="px-1">{{ nots.item.created_at }}</td>
                  <td v-if="nots.item.device.name" class="px-1">{{ nots.item.device.name }}<br><small>{{ nots.item.device.identifier }}</small></td>
                  <td v-else class="px-1 orange--text text--darken-4">{{content.notowned}}</td>
                  <td class="px-1">{{ content.type[nots.item.type] }}</td>
                </template>
                <template v-else v-slot:items="nots">
                  <td>{{ nots.item.created_at }}</td>
                  <td v-if="nots.item.device.name">{{nots.item.device.name}}</td>
                  <td v-else class="orange--text text--darken-4">{{content.notowned}}</td>
                  <td v-if="nots.item.device.identifier">{{nots.item.device.identifier}}</td>
                  <td v-else class="orange--text text--darken-4">{{content.notowned}}</td>
                  <td>{{ content.type[nots.item.type] }}</td>
                  <td>{{ nots.item.read_at }}</td>
                </template>
                <template slot="pageText" slot-scope="item">
                  {{item.pageStart}} - {{item.pageStop}} {{content.of}} {{item.itemsLength}}
                </template>
              </v-data-table>
            </div>
          </template>

        </v-flex>

      </v-layout>

    </v-flex>

  </v-layout>

</template>

<script>

export default {
  data() {
    return {
      locale: Lang.get(),
      loading: true,
      textdir: 'text-xs-left',
    }
  },
  created() {
    this.setLang();
    this.textdir = this.locale == 'he' ? 'text-xs-right' : 'text-xs-left'
    this.setHeaders()
  },
  computed: {
    notifications(){
      let LANG = this.locale == 'he' ? 'he-IL' : (this.locale == 'en' ? 'en-US' : (navigator.language || navigator.userLanguage));
      const OPTIONS = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' , hour:'2-digit', minute:'2-digit'};
      this.loading = false;
      const DEVICES = this.devices;
      const NOTOWNED = this.content.notowned;
      return this.$store.getters['notifications/notifications'].map(function(not){
        not.device = {
          name: null,
          identifier: null,
        };
        if (DEVICES[not.slug]) {
          not.device.name = DEVICES[not.slug].name;
          not.device.identifier = DEVICES[not.slug].identifier;
        }
        not.created_at = !isNaN(not.created_at) ? new Date((not.created_at) * 1000).toLocaleDateString(LANG, OPTIONS) : not.created_at;
        not.read_at = not.read_at ? (!isNaN(not.read_at) ? new Date((not.read_at) * 1000).toLocaleDateString(LANG, OPTIONS) : not.read_at) : '';
        return not;
      });
    },
    devices(){
      return this.$store.getters['devices/devices']
    },
    total(){
      return this.$store.getters['notifications/total']
    },
    perPage(){
      return this.$store.getters['notifications/perPage']
    },
    pagination: {
      get:function() {
        return this.$store.getters['notifications/pagination'];
      },
      set:function(value){
        this.loading = true
        this.$store.dispatch('notifications/fetchNotifications',value)
      }
    },
  },
  methods: {
    setHeaders(){
      this.XSheaders = [
        { text: this.content.headers.short_time, value: 'created_at' },
        { text: this.content.headers.device, value: 'identifier' },
        { text: this.content.headers.not, value: 'type' },
      ];
      this.headers = [
        { text: this.content.headers.time, value: 'created_at' },
        { text: this.content.headers.name, value: 'name' },
        { text: this.content.headers.identifier, value: 'identifier' },
        { text: this.content.headers.not, value: 'type' },
        { text: this.content.headers.read, value: 'read_at' },
      ];
    },
    setLang() {
      if (this.locale == "en") {
        this.content = {
          title: "Notifications History",
          of: "of",
          rowsperpage: "Rows per page",
          noresults: "No Notifications Found",
          notowned: "Not owned anymore",
          headers: {
            time: 'Notified At',
            short_time: 'Time',
            name: 'Device Name',
            device: 'Device',
            identifier: 'Device Identifier',
            not: 'Notification',
            read: 'Read At',
          },
          type: {
            NotConnected: 'Lost power or internet connection',
            IsConnected: 'The power or internet connection is back',
            NoSensor: 'The sensor has disconnected',
            MetTreshold: 'Reached the threshold you set',
            FixedMetTreshold: 'The indicators returned to normal',
            FloodSuspected: 'The buoy identifies flooding',
            FloodFixed: 'The buoy is back to normal',
            DoorOpened: 'The sensor detected a door opening',
            DoorClosed: 'The sensor detected a door closing',
            LowBattery: 'The device has low battery',
          },
        };
      } else if (this.locale == "he") {
        this.content = {
          title: "היסטוריית התראות",
          of: "מתוך",
          rowsperpage: "שורות בעמוד",
          noresults: "לא נמצאו התראות",
          notowned: "כבר לא בבעלות",
          headers: {
            time: 'זמן ההתראה',
            short_time: 'זמן',
            name: 'שם מכשיר',
            device: 'מכשיר',
            identifier: 'מזהה מכשיר',
            not: 'התראה',
            read: 'זמן קריאה',
          },
          type: {
            NotConnected: 'איבד חיבור לחשמל או לאינטרנט',
            IsConnected: 'חזר החיבור לחשמל או לאינטרנט',
            NoSensor: 'החיישן לא מחובר',
            MetTreshold: 'הגיע לסף שהגדרת',
            FixedMetTreshold: 'המדדים חזרו למצב תקין',
            FloodSuspected: 'המצוף מזהה הצפה',
            FloodFixed: 'המצוף חזר למצב תקין',
            DoorOpened: 'החיישן מזהה פתיחה של דלת',
            DoorClosed: 'החיישן מזהה סגירה של דלת',
            LowBattery: 'למכשיר יש סוללה חלשה',
          },
        };
      }
    }
  }
};

</script>
